import { render, staticRenderFns } from "./DomainCategoryModal.vue?vue&type=template&id=6b7be982&"
import script from "./DomainCategoryModal.vue?vue&type=script&lang=ts&"
export * from "./DomainCategoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports